import {getBaseInfo} from "../../api/user";

const state = {
  info: {
    is_required_labor_info: true,
    subordinate_worker: false
  }
}

const mutations = {
  SET_INFO: (state, info) => {
    state.info = info
  }
}

const actions = {
  async setInfo({ commit }) {
    getBaseInfo().then((res) => {
      if (res.data.data) {
        commit('SET_INFO', res.data.data)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/role.js